import { ApiService } from 'services';
import { pick } from 'lodash';

async function getCEXsFromToken(tokenId) {
  const cexMapper = (cex) => {
    return {
      id: cex.cexId,
      url: cex.cexUrl,
      logo: cex.cexLogo,
      ...pick(cex, [
        'depositWalletAddress',
        'depositWalletId',
        'depositWalletStatus',
        'isCexAllowed',
      ]),
    };
  };

  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/cex/token/${tokenId}/me`,
  }).then((cexs) => cexs.map(cexMapper));
}

const addDepositWallet = async ({ cexId, tokenId, walletAddress }) => {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/cex/${cexId}/token/${tokenId}/deposit-wallets`,
    body: {
      walletAddress,
    },
  });
};

const deleteDepositWallet = async ({ cexId, tokenId, depositWalletId }) => {
  return ApiService.callApiAuthenticated({
    method: 'DELETE',
    path: `/cex/${cexId}/token/${tokenId}/deposit-wallets/${depositWalletId}/me`,
  });
};

export default { getCEXsFromToken, addDepositWallet, deleteDepositWallet };
